import {FC} from 'react'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import {checkIsActive, KTSVG, toAbsoluteUrl, WithChildren} from '../../../helpers'
import {useLayout} from '../../core'

type Props = {
  to: string
  title: string
  column?: 4 | 6 | 12
  biIcon?: string
  dtIcon?: string
  faIcon?: string
  image?: string
  variant?: string
  target?: string
  textAlign?: 'left' | 'center'
}

const AsideMenuSub: FC<Props> = ({to, title, column, biIcon, dtIcon, faIcon, image, variant, target, textAlign}) => {
  const {pathname} = useLocation()
  const isActive = checkIsActive(pathname, to)
  const {config} = useLayout()
  const {aside} = config

  return (
    <>
      <div className={`col-${column}`}>
        <Link
          className={clsx(`btn btn-icon btn-active-light-${variant} btn-flex flex-column flex-center h-100 w-100 px-5 py-4`, {
            'align-items-start text-start': textAlign == "left",
            active: isActive,
          })}
          to={to}
          target={target}
        >
          {biIcon && aside.menuIcon === 'font' && <i className={clsx('fs-1 my-1 my-lg-2', biIcon)}></i>}
          {dtIcon && aside.menuIcon === 'svg' && <KTSVG path={dtIcon} className='svg-icon-2 my-1 my-lg-2' />}
          {faIcon && aside.menuIcon === 'font' && <i className={clsx('fs-1 my-1 my-lg-2', faIcon)}></i>}
          {image && <img className='h-30px my-2' src={toAbsoluteUrl(image)} style={{filter: 'grayscale(1) opacity(0.9)'}} />}
          <span
            className={clsx('fs-9 fs-lg-7 lh-sm d-lg-block pt-1', {
              'fw-normal': !isActive,
              'fw-bold': isActive,
            })}
          >
            {title}
          </span>
        </Link>
      </div>
    </>
  )
}

AsideMenuSub.defaultProps = {
  column: 4,
  textAlign: 'center'
}

export {AsideMenuSub}
